import { EActionState } from '@/models';
import { ISendGridTemplate } from '@/models/templates';

export interface ITemplateState {
	email: {
		init: EActionState;
		templates: ISendGridTemplate[];
	};
	sourceEmailTemplate: ISendGridTemplate | null;
	sourceEmailTemplateLoaded: EActionState;
	targetEmailTemplateEnvironment: string;
	targetEmailTemplate: {
		loaded: EActionState;
		data: ISendGridTemplate | null;
	};
	replicateEmailTemplateStatus: EActionState;
}

export const initialState: ITemplateState = {
	email: {
		init: EActionState.PENDING,
		templates: []
	},
	sourceEmailTemplate: null,
	sourceEmailTemplateLoaded: EActionState.PENDING,
	targetEmailTemplateEnvironment: '',
	targetEmailTemplate: {
		loaded: EActionState.PENDING,
		data: null
	},
	replicateEmailTemplateStatus: EActionState.PENDING
};
